<script setup lang="ts">

import {computed} from "vue";
import {NfIconStore} from "@/store/NfIconStore";
import {computedAsync} from "@vueuse/core";

const props = defineProps<{
  icon: string;
  size?: number;
  color?: string;
  stroke?: number;
}>();

const size = computed(() => props.size || 24);

const style = computed(() => ({
  color: props.color ?? '#212121',
  strokeWidth: `${props.stroke ?? 1}px`,
}));

const svg = computedAsync(
    async () => await NfIconStore.get(props.icon),
    ''
);

</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       fill="none"
       :width="size"
       :style="style"
       :height="size">
    <symbol :id="props.icon"
            viewBox="0 0 24 24"
            stroke="currentColor"
            v-html="svg">
    </symbol>
    <use :href="'#' + props.icon"></use>
  </svg>
</template>